module.exports = __webpack_public_path__ + "img/ikon-ru_l.ec4b2a2b.png";